import { ButtonEmptyPermissioned } from "components/ButtonEmptyPermissioned/ButtonEmptyPermissioned";
import { useProjectTablesTableContext } from "components/ProjectTablesTable/provider/ProjectTablesTableProvider";

/**
 * Modal for project tables table to open delete tables modal
 */
export const ButtonDeleteTables = () => {
  const openDeleteTablesModal = useProjectTablesTableContext(
    (s) => s.openDeleteTablesModal,
  );

  return (
    <ButtonEmptyPermissioned
      requiredPermission="edit"
      iconType="trash"
      color="danger"
      onClick={openDeleteTablesModal}
    >
      Delete
    </ButtonEmptyPermissioned>
  );
};
